import actions from "../../constants/actions";

export const loadSearch = (refresh = false, search) => {
    return {
        type: actions.SEARCH.LOAD_LIST,
        payload: {
            refresh,
            options: {
                search,
            },
        },
    };
};
